import React from "react";
import { connect } from "react-redux";
import { BankIdRefererType } from "../../../../../../constants";
import { AnnouncementType, RootState } from "../../../../../../models";
import AnnouncementText from "../../../../checkout/components/atoms/AnnouncementText/AnnouncementText";
import { getBankIdUrl } from "../../../state/selectors";
import "./BankIdCard.less";

interface StateProps {
    bankIdUrl?: string;
}

interface BankIdCardProps extends StateProps {
    referer?: BankIdRefererType;
    typeId?: AnnouncementType;
}

const BankIdCard: React.FC<BankIdCardProps> = ({ typeId }) => {
    return <AnnouncementText typeId={typeId} />;
};

const mapStateToProps: (state: RootState) => StateProps = (state) => ({
    bankIdUrl: getBankIdUrl(state),
});

export default connect(mapStateToProps)(BankIdCard);
